/* NOF theme — vanilla JS, no build. Every block is isolated: if one fails, the rest keeps working. */
(function () {
  'use strict';
  var C = window.NOF || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, currency: 'EUR', locale: 'es', freeShipping: 0, text: {} };
  function safe(fn, n) { try { fn(); } catch (e) { if (window.console) console.warn('[NOF] ' + n, e); } }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function money(cents) {
    try { return new Intl.NumberFormat(C.locale || 'es', { style: 'currency', currency: C.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + (C.currency || ''); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(t) { var el = $('#toast'); if (!el) return; el.textContent = t; el.classList.add('on'); clearTimeout(toast.t); toast.t = setTimeout(function () { el.classList.remove('on'); }, 2400); }
  function json(url) { return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  function init() {
    /* mobile menu */
    safe(function () {
      $$('[data-burger]').forEach(function (b) {
        b.addEventListener('click', function () {
          var h = b.closest('.site-header'); var on = h.classList.toggle('menu-open');
          b.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      });
    }, 'menu');

    /* hero: dots come into focus */
    safe(function () {
      $$('[data-focus-stage]').forEach(function (stage) {
        var cv = $('canvas', stage); if (!cv || !cv.getContext) return;
        var ctx = cv.getContext('2d'), word = stage.getAttribute('data-word') || 'NOF';
        var pts = [], W = 0, H = 0, t0 = 0, mx = -9999, my = -9999, done = false, started = false, visible = true;
        function build() {
          var r = stage.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
          W = Math.floor(r.width); H = Math.floor(r.height); if (!W || !H) return;
          cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          var o = document.createElement('canvas'); o.width = W; o.height = H; var c = o.getContext('2d');
          var fs = Math.min(H * 0.72, W * (1.08 / Math.max(3, word.length)));
          c.fillStyle = '#fff'; c.textAlign = 'center'; c.textBaseline = 'middle';
          c.font = '900 ' + fs + 'px "Archivo", Arial, sans-serif';
          try { c.fontStretch = 'expanded'; } catch (e) {}
          c.fillText(word, W / 2, H / 2 + fs * 0.04);
          var d = c.getImageData(0, 0, W, H).data, step = Math.max(6, Math.round(W / 150)), first = pts.length === 0;
          pts = [];
          for (var y = step / 2; y < H; y += step) for (var x = step / 2; x < W; x += step) {
            if (d[((y | 0) * W + (x | 0)) * 4 + 3] > 128) {
              var a = Math.random() * Math.PI * 2, s = (0.2 + Math.random()) * Math.max(W, H) * 0.5;
              pts.push({ tx: x, ty: y, sx: x + Math.cos(a) * s, sy: y + Math.sin(a) * s * 0.6, ox: 0, oy: 0, r: step * 0.36, dl: Math.random() * 0.35 });
            }
          }
          if (first) t0 = performance.now();
        }
        function ease(t) { return 1 - Math.pow(1 - t, 4); }
        function frame(now) {
          if (!visible) { requestAnimationFrame(frame); return; }
          var T = reduce ? 1 : Math.min(1, (now - t0) / 2200);
          ctx.clearRect(0, 0, W, H); ctx.fillStyle = '#F2F0EB';
          for (var i = 0; i < pts.length; i++) {
            var p = pts[i], k = ease(Math.max(0, Math.min(1, (T - p.dl) / (1 - p.dl))));
            var bx = p.sx + (p.tx - p.sx) * k, by = p.sy + (p.ty - p.sy) * k;
            var dx = bx - mx, dy = by - my, dd = dx * dx + dy * dy, R = 12100;
            if (dd < R) { var f = (1 - dd / R) * 22, len = Math.sqrt(dd) || 1; p.ox += (dx / len * f - p.ox) * .18; p.oy += (dy / len * f - p.oy) * .18; }
            else { p.ox *= .88; p.oy *= .88; }
            ctx.globalAlpha = 0.18 + 0.82 * k;
            ctx.beginPath(); ctx.arc(bx + p.ox, by + p.oy, p.r * (1 + (1 - k) * 2.6), 0, 6.283); ctx.fill();
          }
          ctx.globalAlpha = 1;
          if (T >= 1 && !done) { done = true; stage.classList.add('locked'); var af = $('[data-af]', stage); if (af) af.textContent = af.getAttribute('data-af'); }
          requestAnimationFrame(frame);
        }
        function go() { if (started) return; started = true; build(); stage.classList.add('ready'); t0 = performance.now(); requestAnimationFrame(frame); }
        if (document.fonts && document.fonts.load) document.fonts.load('900 100px "Archivo"').then(go, go);
        setTimeout(go, 1500);
        var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (started) build(); }, 150); });
        stage.addEventListener('pointermove', function (e) { var r = stage.getBoundingClientRect(); mx = e.clientX - r.left; my = e.clientY - r.top; });
        stage.addEventListener('pointerleave', function () { mx = my = -9999; });
        if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(stage);
      });
    }, 'hero');

    /* clock in hero HUD */
    safe(function () {
      $$('[data-clock]').forEach(function (el) {
        var tz = el.getAttribute('data-clock') || 'Europe/Madrid', pre = el.getAttribute('data-prefix') || '';
        function t() { el.textContent = pre + new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: tz }); }
        t(); setInterval(t, 20000);
      });
    }, 'clock');

    /* manifesto: words sharpen as they cross the screen */
    safe(function () {
      $$('[data-manifesto]').forEach(function (el) {
        el.innerHTML = el.textContent.trim().split(/\s+/).map(function (w) { return '<span class="w">' + esc(w) + '</span>'; }).join(' ');
        el.classList.add('js');
        var ws = $$('.w', el);
        function upd() { var mid = innerHeight * 0.62; ws.forEach(function (w) { w.classList.toggle('on', w.getBoundingClientRect().top < mid); }); }
        addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
      });
    }, 'manifesto');

    /* reveals: only below-the-fold items start offset; all visible again after 5s regardless */
    safe(function () {
      var els = $$('.rv'); if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('pre'); io.unobserve(e.target); } }); }, { threshold: 0.04 });
      els.forEach(function (el, i) { if (el.getBoundingClientRect().top > innerHeight) { el.classList.add('pre'); el.style.transitionDelay = (i % 3) * 80 + 'ms'; io.observe(el); } });
      setTimeout(function () { els.forEach(function (e) { e.classList.remove('pre'); }); }, 5000);
    }, 'reveal');

    /* focus cursor */
    safe(function () {
      var fc = $('#fc'); if (!fc || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
      document.documentElement.classList.add('has-cursor');
      var x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y;
      addEventListener('pointermove', function (e) { x = e.clientX; y = e.clientY; fc.classList.toggle('big', !!(e.target.closest && e.target.closest('a,button,label,[data-cur]'))); });
      (function loop() { cx += (x - cx) * .22; cy += (y - cy) * .22; fc.style.transform = 'translate(' + (cx - fc.offsetWidth / 2) + 'px,' + (cy - fc.offsetHeight / 2) + 'px)'; requestAnimationFrame(loop); })();
    }, 'cursor');

    /* cart drawer (Shopify AJAX API) */
    var drawer = $('#cartDrawer'), scrim = $('#scrim');
    function openDrawer() { if (!drawer) return false; drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); scrim.classList.add('on'); document.body.style.overflow = 'hidden'; var x = $('.x', drawer); if (x) x.focus(); return true; }
    function closeDrawer() { if (!drawer) return; drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); scrim.classList.remove('on'); document.body.style.overflow = ''; }
    function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); var b = $('.bagbtn'); if (b) { b.classList.add('bump'); setTimeout(function () { b.classList.remove('bump'); }, 600); } }
    function render(cart) {
      if (!drawer) return;
      var body = $('[data-cart-body]', drawer);
      if (!cart.item_count) {
        body.innerHTML = '<div class="empty"><p class="disp">Bolsa vacía.</p><p>' + esc(C.text.empty || '') + '</p></div>';
      } else {
        body.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? '<img class="f" src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2')) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="">' : '';
          var vt = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
          return '<div class="citem"><a class="ph" href="' + esc(it.url) + '">' + img + '</a><div><h4><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h4>' +
            '<small class="mono">' + vt + money(it.final_price) + '</small>' +
            '<div class="qty"><button data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button><span>' + it.quantity + '</span><button data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Añadir uno">+</button></div></div>' +
            '<button class="mono muted" data-line="' + (i + 1) + '" data-qty="0">Quitar</button></div>';
        }).join('');
      }
      $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
      var bar = $('[data-ship-bar]', drawer), txt = $('[data-ship-text]', drawer);
      if (C.freeShipping > 0 && bar && txt) {
        var left = C.freeShipping - cart.total_price;
        bar.style.width = Math.min(100, cart.total_price / C.freeShipping * 100) + '%';
        txt.textContent = left > 0 ? (C.text.freeLeft || '').replace('[amount]', money(left)) : C.text.freeDone;
      }
      var co = $('[data-checkout]', drawer); if (co) co.disabled = !cart.item_count;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    }
    function refresh() { return json(C.routes.cart + '.js').then(function (c) { render(c); return c; }); }

    safe(function () {
      $$('[data-open-cart]').forEach(function (a) {
        a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); refresh(); openDrawer(); });
      });
      if (scrim) scrim.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
      document.addEventListener('click', function (e) {
        var c = e.target.closest && e.target.closest('[data-close-cart]'); if (c) { closeDrawer(); return; }
        var q = e.target.closest && e.target.closest('#cartDrawer [data-line]'); if (!q) return;
        drawer.classList.add('loading');
        fetch(C.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.getAttribute('data-line'), quantity: Math.max(0, +q.getAttribute('data-qty')) }) })
          .then(function (r) { return r.json(); }).then(render).catch(function () { toast(C.text.error); })
          .then(function () { drawer.classList.remove('loading'); });
      });
    }, 'drawer');

    /* product form: variant picker + AJAX add */
    safe(function () {
      $$('[data-product-form]').forEach(function (root) {
        var dataEl = $('[data-product-json]', root); if (!dataEl) return;
        var product = JSON.parse(dataEl.textContent), form = $('form[action*="/cart/add"]', root);
        var idInput = $('input[name="id"]', form), btn = $('[data-add]', root), hint = $('[data-hint]', root), price = $('[data-price]', root);
        var chosen = product.options.map(function () { return null; });
        var single = product.variants.length === 1;
        if (single) chosen = product.variants[0].options.slice();
        $$('input[data-opt]', root).forEach(function (inp) { if (inp.checked) chosen[+inp.getAttribute('data-opt')] = inp.value; });
        function match() { if (chosen.indexOf(null) > -1) return null; return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0] || null; }
        function markAvailability() {
          $$('input[data-opt]', root).forEach(function (inp) {
            var idx = +inp.getAttribute('data-opt');
            var ok = product.variants.some(function (v) { return v.available && v.options[idx] === inp.value && v.options.every(function (o, i) { return i === idx || chosen[i] === null || o === chosen[i]; }); });
            inp.classList.toggle('na', !ok);
          });
        }
        function update() {
          var v = match(); markAvailability();
          if (!v) { idInput.value = ''; btn.disabled = false; btn.querySelector('[data-label]').textContent = btn.getAttribute('data-add-label'); return; }
          idInput.value = v.id;
          if (price) price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
          btn.disabled = !v.available;
          btn.querySelector('[data-label]').textContent = v.available ? btn.getAttribute('data-add-label') : C.text.soldOut;
          if (hint) hint.textContent = v.available ? (v.title !== 'Default Title' ? v.title : '') : C.text.soldOut;
          if (history.replaceState && !single) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
          var mid = v.featured_media && v.featured_media.id; if (mid) { var m = $('[data-media-id="' + mid + '"]', root.closest('.pdp') || document); if (m && m.parentNode.firstElementChild !== m) m.parentNode.insertBefore(m, m.parentNode.firstElementChild); }
        }
        root.addEventListener('change', function (e) { var t = e.target; if (t.matches('input[data-opt]')) { chosen[+t.getAttribute('data-opt')] = t.value; update(); } });
        form.addEventListener('submit', function (e) {
          if (!idInput.value) { e.preventDefault(); if (hint) hint.textContent = C.text.chooseSize; var c = $('.chips', root); if (c && c.animate) c.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 }); return; }
          if (!drawer || !window.fetch) return; /* plain form post as fallback */
          e.preventDefault(); btn.disabled = true;
          fetch(C.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
            .then(function () { return refresh(); })
            .then(function (c) { setCount(c.item_count); openDrawer(); })
            .catch(function (err) { toast((err && err.description) || C.text.error); })
            .then(function () { btn.disabled = false; update(); });
        });
        update();
      });
    }, 'product');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
